import * as React from 'react';
import styled from '@emotion/styled';
import { tableViewModel } from '../models/views/tableViewModel';

const Label = styled.label`
  color: #555;
  font-size: 12px;
  padding-right: 10px;
  display: block;
  line-height: 2rem;
`;
const B = styled.b`
  font-family: 'Open Sans', 'open sans', sans-serif;
  font-weight: 600;
  color: #474747;
  float: right;
`;
const Td = styled.td`
  padding: 5px 0;
  font-family: 'Open Sans', 'open sans', sans-serif;
  font-size: 12px;
  margin: 0;
  line-height: 2rem;
`;
const Th = styled.th`
  padding: 5px 0;
  font-family: 'Open Sans', 'open sans', sans-serif;
  font-size: 12px;
  margin: 0;
  line-height: 2rem;
  float: left;
  & > b {
    font-size: 14px;
  }
`;
const Tr = styled.tr`
  border-bottom: 1px solid #ddd;
  margin: 0;
  padding: 0;
  line-height: 2rem;
  clear: both;
`;
const Table = styled.table`
  width: calc(100% - 30px);
  margin-bottom: 1rem;
`;

interface Props {
  // vCPUsValue:string
  title: string;
  titleIcon: React.ReactNode;
  data: tableViewModel[];
}

class SummariesTable extends React.Component<Props> {
  render() {
    return (
      <Table>
        <tbody>
          <Tr>
            <Th>
              {this.props.titleIcon}
              <B>{this.props.title}</B>
            </Th>
            <Td />
          </Tr>
          {this.props.data && this.props.data.map(item => (
            <Tr>
              <Td>
                <Label>{item.name}</Label>
              </Td>
              <Td>
                <B>{item.value}</B>
              </Td>
            </Tr>
          ))}
        </tbody>
      </Table>
    );
  }
}

export default SummariesTable;
